import { Stylepack } from '@/types/stylepacks.types';
import { createContext } from 'react';

type TStylepackContext = {
  stylepack: Stylepack;
};
export const SelectedStylepackContext = createContext<TStylepackContext>({
  stylepack: {
    stylePack: '',
    themeId: 0,
    name: '',
    categories: [],
    videos: [],
  },
});
